import store from '../../store';
import { profileInformation } from '../../user';
import { getCustomerUuid } from '../../common-helpers/getCustomerUuid';

const getAdditionalTrackingData = () => {
  return {
    pageSequence: backEndVars.pageSequence || null,
    profile: profileInformation(),
  };
};

export const buildEvent = () => {
  return tracking.event({
    eventType: 'PageView',
    systemType: backEndVars.systemType,
    uri: window.location.pathname,
    domain: window.location.hostname,
    email: store.getAnswers()['saved-email'] || null,
    phone: store.get('__ph') || null,
    customerUuid: getCustomerUuid(),
    additionalData: getAdditionalTrackingData(),
    utmParams: store.getMarketingInfo('lastUtmParams'),
  });
};

export default {
  buildEvent,
};
